import React, { useContext, useEffect, useMemo, useState } from 'react'
import back from "../dist/webImages/back.svg";
import { Field, Form, Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import FormControl from '../components/form/FormControl';
import useFetch from '../customHooks/useFetch';
import SkeletonCreateEdit from './SkeletonCreateEdit';
import CKEditors from '../components/form/CKEditors';
import swal from "sweetalert";
import SubmitButton from '../components/SubmitButton';
import usePost from '../customHooks/usePost';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { toast } from 'react-toastify';
import OneImageUpload from '../components/OneImageUpload';
import { Select } from 'antd';
import dayjs from "dayjs"

const PromotionCreate = ({permission}) => {
      const pageTypeOptions = [
        { label: "Personal Lease", value: "personal_lease" },
        { label: "Lease To Own With Down Payment", value: "lease_with_down" },
        { label: "Lease To Own Without Down Payment", value: "lease_without_down" },
        { label: "Lease To Own With Final Term Payment", value: "lease_final_term" },
        { label: "Rental", value: "rental" },
      ];
      const navigate = useNavigate();
        const [arrow, setArrow] = useState('Show');
        const mergedArrow = useMemo(() => {
          if (arrow === 'Hide') {
            return false;
          }
          if (arrow === 'Show') {
            return true;
          }
          return {
            pointAtCenter: true,
          };
        }, [arrow]);
        const [addCar, setAddCar] = useState()
        const [selectedCar, setSelectedCar] = useState()
        const { loading: loading, data: data } = useFetch(`products/allCars/en/0/1`);
          useEffect(() => {
            if (data) {
              let list = [];
              for (let index = 0; index < data?.data.length; index++) {
                list.push({
                  label: data?.data[index]?.product_title,
                  value: data?.data[index]?.id,
                })
                
              }
              setAddCar(list);
            }
          }, [data]);
    const { mainLanguage } = useContext(MainLanguageContext);
    const [datas, setDatas] = useState({
        "promotion_image": "",
        "promotion_banner": "",
        "brand_logo": "",
        "promotion_short_paragraph": "",
        "promotion_paragraph": "",
        "car_ids": []
    })



    const [imageLoader, setImageLoader] = useState(false)



    const handleCkChange = (e, type) => {
        setDatas(d => ({ ...d, [type]: e }));
    };

        const handleCarsToggle = (e) => {
          setSelectedCar(e);
        }


    let initialValues = {
        promotion_slug: "",
        meta_title: "",
        schedule_date: dayjs().format("YYYY-MM-DDTHH:mm"),
        meta_description: "",
        promotion_title: "",
        promotion_heading: "",
        page_type: "",
        promotion_status: ["1"],
    };
    const [res, apiMethod] = usePost();
    const requireFeild = ["promotion_slug", "meta_title", "meta_description", "promotion_title ", "promotion_heading", "promotion_paragraph", "promotion_status","schedule_date"];
    const handleSubmit = async (values) => {
        if(imageLoader) {
            swal({
              title: "Wait a Few Second",
              icon: "error",
              dangerMode: true,
            });
          }
          else {
        let formdata = new FormData();
        let requireFeildSwal = {
            promotion_slug: "Slug",
            meta_title: "Meta Title",
            meta_description: "Meta Description",
            promotion_title: "Title",
            promotion_heading: "Heading",
            promotion_status: "Status",
            schedule_date: "schedule date",
        };

        let checkerRequried = [];
        for (const item in values) {
            if (requireFeild.includes(item) && !values[item]) {
                checkerRequried.push(requireFeildSwal[item]);
            }
        }

        formdata.append(`translation[meta_title]`, values["meta_title"]);
        formdata.append(`translation[meta_description]`, values["meta_description"]);
        formdata.append(`promotion_slug`, values["promotion_slug"]);
        formdata.append(`page_type`, values["page_type"]);
        formdata.append(`translation[promotion_title]`, values["promotion_title"]);
        formdata.append(`translation[promotion_heading]`, values["promotion_heading"]);
        formdata.append(`schedule_date`, `${values["schedule_date"].replace("T", " ")}` ?? "");
        formdata.append(`promotion_status`, values["promotion_status"]?.length > 0 ? values["promotion_status"] : "0");
        
        if (checkerRequried.length > 0) {
            swal({
                title: "Required Fields are empty! Please fill and try again",
                text: checkerRequried.join(","),
                icon: "error",
                dangerMode: true,
            });
        }
        else {
            formdata.append(`translation[promotion_paragraph]`, datas?.promotion_paragraph);
            formdata.append(`translation[promotion_short_paragraph]`, datas?.promotion_short_paragraph);
            formdata.append(`promotion_image`, datas?.promotion_value ?? "");
            formdata.append(`promotion_banner`, datas?.promotion_banner_value ?? "");
            formdata.append(`brand_logo`, datas?.brand_logo_value ?? "");
            for (let index = 0; index < selectedCar.length; index++) {
                formdata.append(`car_ids[]`, selectedCar[index]);  
            }
            apiMethod(`promotions/create/${mainLanguage}`, formdata)
        }
    }

    }
      useEffect(() => {
        if (res.data) {
          const { status, message } = res?.data
          if (status === "false") {
            toast.error(message);
          }
          else {
            navigate("/promotions")
            toast.success(message);
          }
        }
      }, [res.data])


    if (loading || !data) return <SkeletonCreateEdit heading={"Create Promotions"} />;
    const { promotion_paragraph,promotion_short_paragraph } = datas;
    const check = (module, action) => permission?.[module]?.includes(action);
    return (
        <section className='PromotionCreate pr-10 max-lg:pr-6'>
            <Link to={"/promotions"} className="back flex items-center mb-5 gap-2">
                <img src={back} className='w-[2rem]' alt="" />
                <span className='text-[1.4rem] font-MluvkaBold'>Create Promotions</span>
            </Link>
            <div className='relative flex items-start gap-3'>
                <div className=' bg-white rounded-xl w-full  mx-auto relative'>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} >
                        <Form name="myForm">
                            <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-3'>
                                <div className="grid grid-cols-2 gap-2">
                                    <FormControl name="promotion_slug" label={"Slug"} placeholder="Enter Slug" className="outline-none w-full h-[3rem] px-5 rounded-xl border border-[red]" control="input2" />
                                    <FormControl name="meta_title" label={"Meta Title"} placeholder="Enter Meta Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
                                </div>
                                <div className="grid  gap-2">
                                    <FormControl name="meta_description" label={"Meta Description"} placeholder="Enter Meta Description" className="outline-none w-full h-[10rem] px-5 py-3 rounded-xl resize-none" control="textarea2" />
                                </div>
                            </div>
                            <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3'>
                                <div className="h4 text-[#7D8CA7] text-[1.1rem] ">Promotion</div>
                                <FormControl name="promotion_title" label={"Title {h1}"} placeholder="Enter Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
                                <FormControl name="promotion_heading" label={"Heading"} placeholder="Enter Heading" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
                                <div className="mt-3">
                                    <label htmlFor="page_type" className="mb-1 block text-[#7D8CA7] text-[.8rem]">Page Type</label>
                                    <Field as="select" id="page_type" name="page_type" className="outline-none w-full h-[3rem] px-5 rounded-xl border border-[#D1D5DB] bg-white">
                                        <option value="">Select Page Type</option>
                                        {pageTypeOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                                    </Field>
                                </div>
                                <br />
                                <div className="mb-1 block text-[#7D8CA7] text-[.8rem]">Short Paragraph</div>
                                <CKEditors label={"Short Paragraph"} data={promotion_short_paragraph} update={(text) => handleCkChange(text, "promotion_short_paragraph")} />
                                <br />
                                <div className="mb-1 block text-[#7D8CA7] text-[.8rem]">Main Paragraph</div>
                                <CKEditors label={"Main Paragraph"} data={promotion_paragraph} update={(text) => handleCkChange(text, "promotion_paragraph")} />

                                <br />
                                <br />

                                <label className="mb-1  mt-3 block text-[#7D8CA7] text-[.8rem]">Brand Logo </label>
                                <OneImageUpload changeImage={setImageLoader} MainImage={datas?.brand_logo} Update={setDatas} sec_value={"brand_logo_value"} sec_image={"brand_logo"} folder_name={"promotion-images"} page_type={"Promotions"} />
                                <div className='mt-4'>
                                    <div>
                                        <label className="mb-1  mt-3 block text-[#7D8CA7] text-[.8rem]">Promotion Image </label>
                                <OneImageUpload changeImage={setImageLoader} MainImage={datas?.promotion_image} Update={setDatas} sec_value={"promotion_value"} sec_image={"promotion_image"} folder_name={"promotion-images"} page_type={"Promotions"} />
                                    
                                    </div>
                                    <div>
                                        <label className="mb-1  mt-3 block text-[#7D8CA7] text-[.8rem]">Promotion Banner </label>
                                        <OneImageUpload changeImage={setImageLoader} MainImage={datas?.promotion_banner} Update={setDatas} sec_value={"promotion_banner_value"} sec_image={"promotion_banner"} folder_name={"promotion-images"} page_type={"Promotions"} />
                                    </div>
                                </div>

                                <div className="mt-4">


                  <div className='relative'>
              <FormControl name="schedule_date" label={"Schedule"} type={'datetime-local'} placeholder="Enter Schedule" className="outline-none mmonth w-full h-[3rem] px-5 rounded-xl" control="input2" />
            </div>
      {addCar &&      <div className='antdheight'>
                <div className="h4 text-[#7D8CA7] text-[.8rem] mb-1">Product List</div>
                <Select
                 showSearch
                  mode="multiple"
                  placeholder="Please select"
                  onChange={(e) => handleCarsToggle(e)}
                  style={{
                    width: '100%',
                  }}
                  options={addCar}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                />
              </div>}
                </div>

                                <div className="overflow-hidden relative pt-7 px-4">
                                    <label className="inline-flex items-center cursor-pointer">
                                        <Field value="1" type="checkbox" name="promotion_status" className="sr-only peer" />
                                        <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none  rounded-full peer bg-gray-200 peer-checked:after:translate-x-full   after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                                        <span className="ms-3 text-sm font-medium text-gray-900">Promotion Status</span>
                                    </label>
                                </div>

                            </div>

                            {check("Promotions", "Promotion Edit") &&<SubmitButton
                                props={{
                                    class: "btn bg-secondary text-white px-12 ml-auto uppercase mb-3   py-3 rounded-full w-100 block mt-5 submit hover:bg-primary transition-all duration-300",
                                    text: "Submit",
                                }}
                                buttonLoading={res.isLoading}
                            />}

                        </Form>
                    </Formik>
                </div>
            </div>
        </section>
    )
}

export default PromotionCreate
